import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Divider,
  FormControlLabel,
  FormGroup,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSnapshot } from "valtio";
import * as ApiCall from "../../API/ApiCalling";
import { widState } from "../../../Store/workdriveState";
import MySortableTree, {
  baseTreeData,
} from "../../Others/SortableTree/MySortableTree";
import SnackAlert from "../../RelatedList/srcfolder/components/WorkDrive/Others/SnackAlert";
import ModuleHistoricData from "./ModuleHistoricData";
import { EXTENSION_IDENTIFIER } from "../../../config/serviceConstant";

const ZOHO = window.ZOHO;
function ProcessHistoricDataNew(props) {
  const {
    zapikey,
    orgid,
    connname,
    apikey,
    datacenterurl,
    zuid,
    handleClose,
    toggle,
    setToggle,
  } = props;

  const snap = useSnapshot(widState);
  const [loading, setLoading] = useState(false);
  const [moduleList, setModuleList] = useState([]);
  const [customViewList, setCustomViewList] = useState([]);
  const [rootFolder, setRootFolder] = useState({});
  const [customSettingData, setCustomSettingData] = useState({});
  const [module, setModule] = useState({});
  const [customView, setCustomView] = useState({});
  const [folderField, setFolderField] = useState({});

  const [isValid, setValid] = useState(false);
  const [treeData, setTreeData] = useState(baseTreeData);

  const [message, setMessage] = useState();
  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState("success");
  const [step, setStep] = useState(0);

  const handleCloseSnackbar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const saveTreeData = (data) => {
    const { key, response } = data;
    setTreeData((prev) => response);
  };

  const createCronJob = async ({ executeConfigSettingId }) => {
    const { workspace, teamFolder, rootFolder, folderField, treeData } =
      customSettingData;

    // {
    //   url: `https://plugin-easyworkdriveforcrm.zohosandbox.com/crm/v2/functions/easyworkdriveforcrm__execute_cron_v5/actions/execute?auth_type=apikey&zapikey=1001.d8c9461adbe6404a6a75adb538530cad.103554dd33424d3ec758705c09dd58c7`,
    //   headers: reqHeaders,
    //   body,
    //   params,
    //   type,
    //   name,
    // }

    // Create cron
    // todo Create CRON with Setting ID/UUID in the Rest API URL
    let cronHeaders = {
      orgid: orgid,
      apikey: apikey,
      connname: EXTENSION_IDENTIFIER,
      "content-type": "application/json",
      datacenterurl: datacenterurl,
    };
    let cronFetchUrl =
      datacenterurl +
      "/crm/v2/functions/easyworkdriveforcrm__execute_cron_v5/actions/execute?auth_type=apikey&zapikey=" +
      zapikey +
      "&setting_id=" +
      executeConfigSettingId;

    // cronFetchUrl = `https://plugin-easyworkdriveforcrm.zohosandbox.com/crm/v2/functions/easyworkdriveforcrm__execute_cron_v5/actions/execute?auth_type=apikey&zapikey=1001.d8c9461adbe6404a6a75adb538530cad.103554dd33424d3ec758705c09dd58c7&setting_id=${executeConfigSettingId}`;
    let reqBody = {
      moduleApiName: module?.apiName,
      module,
      customView,
      executeConfigSettingId: executeConfigSettingId,
    };
    let data = {
      url: cronFetchUrl,
      headers: {},
      body: reqBody,
      params: {},
      type: "POST",
      name: `${orgid}__${EXTENSION_IDENTIFIER}`,
      execute_in: 1,
    };

    // {"url":crm_url,"name":title,"headers":Map(),"body":Map(),"params":Map(),"type":"GET","execute_in":1}
    // create_cron = invokeurl
    // [
    // 	url :ADMIN_API_URL + "/utils/cronjoborg"
    // 	type :POST
    // 	parameters:data.toString()
    // 	headers:my_headers
    // ];

    try {
      const createJob = await ApiCall.createCronJobOrg(data, cronHeaders);
      if (createJob?.data) {
        // setMessage("Created Successfully..");
        // setSeverity("success");
        // setOpen(true);
        handleClose();
        setToggle(!toggle);
      } else {
        setMessage(createJob?.error);
        setSeverity("error");
        setOpen(true);
      }
    } catch (error) {
    }
  };

  const handleCreateCronSetting = async (event) => {
    const { workspace, teamFolder, rootFolder, folderField, treeData } =
      customSettingData;

    const settingSchema = {
      newFolderStructure: true,
      moduleApiName: module?.apiName,
      module,
      customView,
      workspace,
      teamFolder,
      rootFolder,
      folderField,
      treeData,
    };

    const insertedData = await axios.request({
      url: `${process.env.REACT_APP_ADMIN_SERVER_URL}/db/planetscale/clients/settings`,
      method: "POST",
      data: {
        settingSchema: settingSchema,
        showInRelatedList: false,
        moduleApiName: module?.apiName,
        settingType: "executeConfigForCron",
      },
      headers: {
        orgid: orgid,
        apikey: apikey,
        datacenterurl: datacenterurl,
        connname: EXTENSION_IDENTIFIER,
      },
    });

    const executeConfigSettingId = insertedData?.data?.data?.setting_id || "";

    if (executeConfigSettingId !== "") {
      await createCronJob({ executeConfigSettingId });
    }
  };

  async function getCustomView(module) {
    if (!module?.apiName) {
      setCustomViewList((prev) => []);
      return;
    }
    const { displayName: moduleDisplayName, apiName: moduleApiName } = module;
    try {
      const customViewResp = await ZOHO.CRM.META.getCustomViews({
        Entity: moduleApiName,
      });
      const customViews = customViewResp?.custom_views?.map((cv) => {
        return { name: cv?.name, id: cv?.id };
      });
      setCustomViewList((prev) => customViews);
    } catch (error) {}
  }

  useEffect(() => {
    async function getModules() {
      ZOHO.CRM.META.getModules().then(function (data) {
        let modules = data?.modules
          ?.filter((module) => module?.isBlueprintSupported)
          ?.map((module) => {
            return {
              displayName: module.plural_label,
              apiName: module.api_name,
            };
          });
        // let filteredModule = modules?.filter(
        //   (element) => !inProgressModuleList.includes(element)
        // );
        setModuleList(modules);
      });
    }
    getModules();
  }, []);

  useEffect(() => {
    async function getRecordCount() {
      const data = {
        moduleApiName: module?.apiName,
        cvid: customView?.id,
        connname,
        orgid,
        apikey,
        datacenterurl,
      };
      const recordCount = await ApiCall.countRecordOfCustomView(data);

      const MAX_PROCESS_RECORD = 35000;
      if (true ) {
        setValid(true);
      }

      if(recordCount?.data > MAX_PROCESS_RECORD){
        
        setMessage(`${customView?.name} has ${recordCount?.data} records. Processing ${recordCount?.data} records may required ${Number(recordCount?.data) *12 } API.` );
        setSeverity("warning");
        setOpen(true);
      }
    }
    if (step == 1) {
      setValid((prev) => false);
    } else if (step == 2) {
      getRecordCount()
      // setTreeData((prev) => widState?.settingData?.[module?.apiName]?.treeData);
      // setRootFolder((prev) => widState?.settingData?.[module?.apiName]?.rootFolder);
      // fix (workspace, team, rootFolder id) or fieldapiName and folderstructure
      
    }
  }, [step]);

  useEffect(() => {
    getCustomView(module);
    setCustomView((prev) => null);
    setFolderField((prev) => null);
    setTreeData((prev) => null);
    setRootFolder((prev) => null);
  }, [module?.apiName]);

  return (
    <>
      <Box
        sx={{
          bgcolor: "#FAF9F6",
          p: "2rem",
          overflowY: "auto",
          maxHeight: "80vh",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <Box sx={{ display: "flex", gap: "2rem" }}>
          <Box>
            <Typography sx={{ fontWeight: 500, fontSize: "14px" }}>
              Select Module
            </Typography>

            <Autocomplete
              disablePortal
              id="combo-box-demo"
              value={
                module?.apiName
                  ? {
                      displayName: module.displayName,
                      apiName: module.apiName,
                    }
                  : null
              }
              options={moduleList}
              getOptionLabel={(option) => option.displayName}
              onChange={(error, value) => {
                if (value) {
                  setModule((prev) => {
                    return {
                      displayName: value.displayName,
                      apiName: value.apiName,
                    };
                  });

                  widState.setSelectedSetting(value.apiName);
                  setStep((prev) => 1);
                } else {
                  setCustomSettingData((prev) => {});
                  setModule((prev) => {});
                  setStep((prev) => 0);
                }
              }}
              size="small"
              sx={{ width: 550, my: ".5em" }}
              renderInput={(params) => <TextField {...params} />}
            />
            {/* <Typography sx={{ color: "#878787", fontSize: 14 }}>
              Select Field <span>(Where you want to save folder id)</span>
              <span>
                (Fields present in
                {customView?.name ? ` '${customView?.name}'` : ""} custom view
                criteria will not be available)
              </span>
            </Typography> */}
          </Box>

          <Box>
            <Typography sx={{ fontWeight: 500, fontSize: "14px" }}>
              Select Custom View
            </Typography>

            <Autocomplete
              disablePortal
              // disabled={step == 1 && customViewList?.length ? false : true}
              id="combo-box-demo"
              value={
                customView?.id
                  ? {
                      name: customView?.name,
                      id: customView?.id,
                    }
                  : null
              }
              options={customViewList}
              getOptionLabel={(option) => option.name}
              onChange={(error, value) => {
                if (value) {
                  setCustomView((prev) => {
                    return {
                      name: value?.name,
                      id: value?.id,
                    };
                  });

                  // setCustomSettingData(
                  //   (prev) => widState?.settingData?.[module?.apiName] || {}
                  // );

                  // setTreeData(
                  //   (prev) =>
                  //     widState?.settingData?.[module?.apiName]?.treeData
                  // );

                  setStep((prev) => 2);
                } else {
                  setCustomView((prev) => {});
                  setStep((prev) => 1);
                }
              }}
              size="small"
              sx={{ width: 550, my: ".5em" }}
              renderInput={(params) => <TextField {...params} required />}
            />
            {/* <Typography sx={{ color: "#878787", fontSize: 14 }}>
              Select Field <span>(Where you want to save folder id)</span>
              <span>
                (Fields present in
                {customView?.name ? ` '${customView?.name}'` : ""} custom view
                criteria will not be available)
              </span>
            </Typography> */}
          </Box>
        </Box>
        {step >= 2 && (
          <ModuleHistoricData
            key={module.apiName}
            index={0}
            module={module.apiName}
            orgid={orgid}
            connname={connname}
            apikey={apikey}
            datacenterurl={datacenterurl}
            zuid={zuid}
            settingSchema={customSettingData}
            setSettingSchema={setCustomSettingData}
          />
        )}

        <Box>
          <Button
            variant="outlined"
            onClick={handleClose}
            sx={{ mr: 2 }}
            size="small"
          >
            Cancel
          </Button>
          <Button
            disabled={!isValid}
            variant="contained"
            onClick={handleCreateCronSetting}
            sx={{ width: 220 }}
            size="small"
          >
            Create Cron Job
            {loading && (
              <CircularProgress sx={{ color: "white", ml: 1 }} size={16} />
            )}
          </Button>
        </Box>
      </Box>
      <SnackAlert
        duration={7000}
        snackOpen={open}
        handleCloseSnack={handleCloseSnackbar}
        severity={severity}
        message={message}
      />
    </>
  );
}

export default ProcessHistoricDataNew;
